"use client";

import { Button } from "@/components/ui/button";
import { RefreshCcw, Circle } from "lucide-react";
import React from "react";
import { useEffect, useState, useRef } from "react";
import { DebouncedInput } from "@/components/ui/debouncedInput";
import { animate, svg, createScope } from 'animejs';

export function DataTableTabs() {
    return (
        <div className="flex flex-col">

        </div>
    );
}
